import { FormTextFieldProps } from '@/services/types/franchise.type';
import { FormElementType } from '@/services/types/globals.type';
import {
  AwardCardProps,
  PrivacyPolicyProps,
  ProcessCardProps,
  WhyCardProps,
} from '@/types/franchise.type';

// 왜 드라이빙존 운전면허인가
export const WHY_CARD_DATA: WhyCardProps[] = [
  {
    idx: 1,
    icon: '/images/franchise/desc_card_icon1.svg',
    title: `업계 트렌드를 선도하는
    최고의 제품 기술력`,
    description: `전국 국가운전면허시험장에
    시뮬레이터를 제작 및 공급해온
    검증된 기술력을 가진 전문기업
    그리드스페이스(주)의 독점 판매처`,
  },
  {
    idx: 2,
    icon: '/images/franchise/desc_card_icon2.svg',
    title: `기업 철학인 상생을
    바탕으로 한 가맹 정책`,
    description: `본사와 매장주의 상생을
    기업 핵심가치로 구축하여
    합리적인 정책으로
    모든 가맹점 운영을 지원`,
  },
  {
    idx: 3,
    icon: '/images/franchise/desc_card_icon3.svg',
    title: `성공적 창업을 위한
    본사의 지속적 관리 및 지원`,
    description: `전담 매니저를 통한 매장 별
    맞춤 컨설팅 및 운영 정책 수립 등
    성공적인 창업을 위한 지속적인
    본사의 관리와 마케팅 지원`,
  },
];

// 창업절차
export const FRANCHISE_PROCESS_DATA: ProcessCardProps[] = [
  {
    idx: 1,
    title: '창업 상담',
    description: '사업 설명 및 상담 진행',
  },
  {
    idx: 2,
    title: '상권 분석',
    description: '상권 분석 결과 공유 및 상담',
  },
  {
    idx: 3,
    title: '계약 작성',
    description: '가맹 및 시뮬레이터, 점포 계약',
  },
  {
    idx: 4,
    title: '인테리어',
    description: '인테리어 견적 및 시공',
  },
  {
    idx: 5,
    title: '사전 마케팅',
    description: '본사 지원 사전 마케팅',
  },
  {
    idx: 6,
    title: '점주 교육',
    description: '코칭 노하우 및 커리큘럼 안내',
  },
  {
    idx: 7,
    title: '매장 오픈',
    description: 'GRAND OPEN',
  },
  {
    idx: 8,
    title: '사후 관리',
    description: '오픈 후 본사 마케팅 지원',
  },
];

// 수상 내역
export const AWARD_CARD_DATA: AwardCardProps[] = [
  {
    idx: 1,
    awardEng: 'Korea Satisfaction Consumer Index',
    awardKor: `한국 소비자
    만족지수`,
    rank: '1위',
  },
  {
    idx: 2,
    awardEng: 'Consumer Satisfaction Brand Awards',
    awardKor: `소비자만족
    브랜드 대상`,
    rank: '1위',
  },
  {
    idx: 3,
    awardEng: 'Korea Hit Brand Award',
    awardKor: `대한민국 히트
    브랜드 대상`,
    rank: '1위',
  },
  {
    idx: 4,
    awardEng: 'First Brand Award 2022',
    awardKor: `대한민국 퍼스트
    브랜드 대상`,
    rank: '1위',
  },
];

// 등록 폼 데이터
export const REGISTER_TEXT_FORM_DATA: FormTextFieldProps[] = [
  {
    label: '이름',
    name: 'realname',
    placeholder: '이름을 입력해주세요.',
    isRequired: true,
    elementType: FormElementType.Text,
  },
  {
    label: '점주 연령대',
    name: 'ageGroup',
    placeholder: 'ex) 40대, 50대',
    isRequired: true,
    elementType: FormElementType.Select,
  },
  {
    label: '연락처',
    name: 'phoneNumber',
    placeholder: '연락처를 입력해주세요.',
    isRequired: true,
    elementType: FormElementType.Text,
  },
  {
    label: '이메일',
    name: 'email',
    placeholder: '이메일 형식으로 입력해주세요',
    isRequired: true,
    elementType: FormElementType.Text,
  },
  {
    label: '희망지역',
    name: 'regionTxt',
    placeholder: 'ex) 서울 노원, 인천 구월',
    isRequired: true,
    elementType: FormElementType.Text,
  },
  {
    label: '예산',
    name: 'budget',
    placeholder: '생각하고 있는 예산을 입력해주세요.',
    isRequired: true,
    elementType: FormElementType.Text,
  },
  {
    label: '상담내용',
    name: 'content',
    placeholder: '상담하고 싶은 내용을 입력해주세요',
    isRequired: true,
    elementType: FormElementType.Textarea,
  },
];

export const PRIVACY_POLICY_DATA: PrivacyPolicyProps[] = [
  {
    idx: 1,
    title: '수집하는 개인정보 항목',
    description: '성명, 연락처, 연령대, 이메일, 희망지역, 예산, 상담내용',
  },
  {
    idx: 2,
    title: '고객정보의 수집 및 이용목적',
    description:
      '회사는 상담안내(SMS,TM)를 위해 개인정보를 수집 및 이용합니다.',
  },
  {
    idx: 3,
    title: '고객정보 보유 및 이용기간',
    description:
      '회사는 개인정보 수집 및 처리목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.',
  },
  {
    idx: 4,
    title: '개인정보 수집 동의 거부의 권리',
    description:
      '개인정보 제공에 거부할 수 있으며, 동의 거부시 이용정보 안내 등 서비스 이용에 제한이 있을 수 있습니다.',
  },
  {
    idx: 5,
    title: '개인정보 수집 주체',
    description: '(주)드라이빙존 운전면허',
  },
  {
    idx: 6,
    title: '고객정보 수집 및 이용동의 철회',
    description:
      '고객정보 제공 및 이용을 원하지 않을 경우 철회요청 할 수 있습니다.',
  },
];
